import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios"
const SyncCourses = () => {
  const [inProcess, setInProcess] = useState(false);
  const syncCourses = () => {
    setInProcess(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Courses/SyncCourses",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync Courses Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        toast.success("Sync Courses Process Finished");
        syncUserCourses();
      } else {
        toast.error("Sync Courses Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  const syncUserCourses = () => {
    setInProcess(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Courses/SyncUserCourses",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync User Courses Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        syncCourseAssignments()
        toast.success("Sync User Courses Process Finished");
      } else {
        toast.error("Sync User Courses Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  const syncCourseAssignments = () => {
    setInProcess(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Courses/SyncCourseAssignments",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync Course Assignments Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        syncCourseAssignmentsSubmissions();
        toast.success("Sync Course Assignments Process Finished");
      } else {
        toast.error("Sync Course Assignments Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  const syncCourseAssignmentsSubmissions = () => {
    setInProcess(true);
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Courses/SyncCourseAssignmentsSubmissions",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };
    toast.info("Sync Course Assignments Submissions Process Started");
    api(config).then(function (response) {
      if (response.status === 200) {
        toast.success("Sync Course Assignments Submissions Process Finished");
      } else {
        toast.error("Sync Course Assignments Submissions Process Failed, please check support");
      }
      setInProcess(false);
    });
  };
  return (
    <>
      <button onClick={() => syncCourses()}>Sync Courses</button>
    </>
  );
};

export default SyncCourses;
